import { client } from "@/client";
import { TenderState, TenderStateFragmentDoc } from "@/graphql/__generated__/graphql";
import { DocumentNode } from "graphql";
import merge from "lodash/merge";

/**
 * Merge new data with cached data to ensure cache is valid
 * @param query
 * @param key
 * @param newData
 */
export const updateCache = (query: DocumentNode, key: string, newData: any) => {
  const existingData = client.readQuery({ query });

  const mergedData = merge({}, existingData, {
    [key]: newData
  });

  client.writeQuery({
    query,
    data: mergedData
  });
};

/**
 * Updates the state of a tender in the Apollo Client cache by tender ID.
 *
 * @param {TenderState} tenderState - The tender state to be written to cache.
 */
export const updateTenderState = (tenderState: TenderState, tenderID: string) => {
  client.writeFragment({
    fragment: TenderStateFragmentDoc,
    id: `Tender:${tenderID}`,
    data: {
      __typename: "Tender",
      state: tenderState
    }
  });
};
